export const getIndexName = (indexName: string) => {
  return `${
    process.env.ALGOLIA_INDEX_PREFIX
      ? process.env.ALGOLIA_INDEX_PREFIX + '_'
      : ''
  }${indexName}`
}
